const metaAuth = {
  auth: 1,
  keepAlive: false,
};

export default [
  {
    path: "/wb",
    name: "wb",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/2345",
    name: "2345",
    meta: metaAuth,
    component: () => import("@/views/basePcThree/index.vue"),
  },
  {
    path: "/by",
    name: "by",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/biyingxxl",
    name: "biyingxxl",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/3dm",
    name: "3dm",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  // {
  //   path: "/biyingjj",
  //   name: "biyingjj",
  //   meta: metaAuth,
  //   component: () => import("@/views/basePc/index.vue"),
  // },
  {
    path: "/iqiyi",
    name: "iqiyi",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/lx",
    name: "lx",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/cnxh",
    name: "cnxh",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/tieba",
    name: "tieba",
    meta: metaAuth,
    component: () => import("@/views/tieba/index.vue"),
  },
  {
    path: "/xunyou",
    name: "xunyou",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/07073",
    name: "07073",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/sw360",
    name: "sw360",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/xunlan",
    name: "xunlan",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/yueke1",
    name: "yueke1",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/baidu7",
    name: "baidu7",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/sougou4",
    name: "sougou4",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/sougou5",
    name: "sougou5",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/baidu14",
    name: "baidu14",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
  {
    path: "/pdyk",
    name: "pdyk",
    meta: metaAuth,
    component: () => import("@/views/basePc/index.vue"),
  },
];
